<div class="full-height layout-column overflow-x-auto-only">

  <div class="flex layout-column bringoz-table">

    <div class="tr layout-row layout-align-start-center" id="header">
      <div class="th flex-15">
        <span translate>AI Agent Name</span>
      </div>
      <div class="th flex" translate>Description</div>
      <div class="th flex-5" translate>Active</div>
      <div class="th flex-10" translate>Created At</div>
      <div class="th flex-10" translate>Updated At</div>
      <div class="th flex-5"></div>
    </div>

    <div class="full-height flex layout-column">
      <cdk-virtual-scroll-viewport itemSize="60" class="flex viewport" (scroll)="getNextBatch()">
        <app-ai-agents-table-row *cdkVirtualFor="let aiAgent of aiAgents"
                             class="item"
                             [aiAgent]="aiAgent"
                             [allowEdit]="allowEdit"
                             [allowDelete]="allowDelete"
                             (editAiAgentEvent)="editAiAgentEvent.emit($event)"
                             (deleteAiAgentEvent)="deleteAiAgentEvent.emit($event)">
        </app-ai-agents-table-row>
      </cdk-virtual-scroll-viewport>
    </div>

  </div>

</div>

